var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopicsNoAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 242,
    height: 192,
    viewBox: "0 0 242 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4234",
    x: 0,
    y: 0,
    width: 236,
    height: 186,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Analysis_not_found",
    "data-name": "Analysis not found",
    transform: "translate(-1981 -896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6714",
    "data-name": "Group 6714",
    transform: "translate(1440 -2650)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 541, 3546)",
    filter: "url(#Rectangle_4234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4234-2",
    "data-name": "Rectangle 4234",
    width: 218,
    height: 168,
    rx: 5,
    transform: "translate(9 6)",
    fill: "#e6ebf4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(560 3558)",
    fill: "#769eb0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(573 3558)",
    fill: "#769eb0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    transform: "translate(585 3558)",
    fill: "#769eb0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6699",
    "data-name": "Group 6699",
    transform: "translate(568.028 205)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5369",
    "data-name": "Rectangle 5369",
    width: 198,
    height: 30,
    rx: 5,
    transform: "translate(-8.028 3379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5377",
    "data-name": "Rectangle 5377",
    width: 198,
    height: 80,
    rx: 5,
    transform: "translate(-8.028 3417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(75.972 3429)",
    fill: "#e6ebf4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_234",
    "data-name": "Ellipse 234",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(87.972 3429)",
    fill: "#e6ebf4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_235",
    "data-name": "Ellipse 235",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(99.972 3429)",
    fill: "#e6ebf4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6713",
    "data-name": "Group 6713",
    transform: "translate(1418.73 709.029)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5375",
    "data-name": "Rectangle 5375",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(725 297)",
    fill: "#e6ebf4",
    stroke: "#7e9dae",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_374",
    "data-name": "Line 374",
    x1: 16,
    y1: 16,
    transform: "translate(763.975 338.939)",
    fill: "none",
    stroke: "#7e9dae",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_375",
    "data-name": "Line 375",
    x1: 16,
    y1: 16,
    transform: "translate(747 309)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_376",
    "data-name": "Line 376",
    x1: 6,
    y1: 6,
    transform: "translate(757 309)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5376",
    "data-name": "Rectangle 5376",
    width: 16,
    height: 32,
    rx: 3,
    transform: "translate(770.328 356.343) rotate(-45)",
    fill: "#7e9dae"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicsNoAnalysis);
export default __webpack_public_path__ + "static/media/topics-no-analysis.6173ab27f32b0d332b18547bcb6ea163.svg";
export { ForwardRef as ReactComponent };